// extracted by mini-css-extract-plugin
export default {"button":"button_button__V-xVv","FromRight":"button_FromRight__SbW4-","ring":"button_ring__NGv-z"};